import { h$1 as M, Y as g, b as y, v as C, u as A, a as T, h as d, me as D, m as V, o as F } from "../chunks/register-Ba9sFUKZ.js";
import * as U from "react";
import { le as K } from "../chunks/focus-trap.esm-DaVNyTE9.js";
import { E as f, A as E } from "../chunks/keys-KoEjL9PG.js";
import { r as h, r$1 as N, a as L, e as S } from "../chunks/tab-CGM5ipmz.js";
import { h as j } from "../chunks/arrow-control-BGs9kWYY.js";
import { v as Y } from "../chunks/mixin-CP6jLr_x.js";
import { f as G } from "../chunks/lifecycle-decorators-C04d1yHY.js";
import { A as p, E as W, q as R } from "../chunks/query-assigned-DFc_RnLg.js";
import { c as X, n as H } from "../chunks/scroll-CyO1WAss.js";
import { t as q } from "../chunks/uid-DGLBmjXH.js";
import { M as z } from "../chunks/breakpoints-C1cfupNh.js";
var v = /* @__PURE__ */ ((e) => (e[e.DEFAULT = 4] = "DEFAULT", e[e.MEDIUM = 5] = "MEDIUM", e[e.LARGE = 7] = "LARGE", e[e.XLARGE = 7] = "XLARGE", e))(v || {});
const Z = M`:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-5);--tabs-size-block-size-secondary: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating) + var(--caption-300-line-height) + var(--beacon-system-width-border-normal));--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-8);--tabs-menu-item-space-padding: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tabs-menu-item-space-margin-block-start: var(--beacon-reference-space-5);--tabs-menu-max-block-size: 100%;--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 6 + var(--beacon-system-space-gutter) * 5);--tabs-menu-item-block-size: var(--beacon-reference-space-12);--tabs-tab-title-space-margin-block-end: 0;--tabs-tab-title-space-margin-block-start: 0;--tabs-tab-title-space-margin-inline: 0;--tabs-tab-icon-space-margin-block: 0;--tabs-tab-icon-space-margin-inline-start: 0;--tabs-tab-title-space-secondary-margin-block-start: 0;--tabs-tab-title-space-secondary-margin-inline-start: 0;--tabs-tab-size-block-size-default: var(--beacon-reference-space-11);--tabs-tab-size-block-size-with-icon: var(--beacon-reference-space-14);--tabs-menu-item-space-padding-block-start: 0;--tab-padding: calc(2 * var(--beacon-system-space-cell-contained));--tab-space-secondary-padding-block: calc(var(--beacon-system-space-cell-contained) + var(--beacon-system-space-cell-free-floating));--tab-icon-align-self: center;--tab-span-align-self: center;--tabs-tab-size-min-inline-size: fit-content;--tabs-tab-size-max-inline-size: unset;--tabs-tab-flex-direction: row}@media (width >= 640px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-6);--tabs-tab-size-block-size-default: 3.25rem;--tabs-menu-item-space-margin-block-start: 0;--tabs-menu-max-block-size: calc(var(--tabs-menu-item-block-size) * 9 + var(--beacon-reference-space-10) + 40px);--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--tabs-menu-item-block-size: 3.75rem;--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-9)}}@media (width >= 960px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs]{--caption-300-line-height: var(--beacon-reference-space-7);--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 8 + var(--beacon-system-space-gutter) * 7)}}@media (width >= 1280px){:root[beacon-tag-name=beacon-tabs],:root [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][class*=beacon-on] [beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[class*=beacon-on] [beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"][beacon-tag-name=beacon-tabs],[beacon-version="4.2.2"] [beacon-tag-name=beacon-tabs]{--tabs-tab-size-block-size-tertiary: var(--beacon-reference-space-10);--tabs-tab-size-block-size-with-icon: calc(19 * var(--beacon-reference-space-2));--tabs-menu-max-inline-size: calc(calc((min(100vw - 2 * var(--beacon-system-space-organism-maxi), var(--beacon-system-breakpoint-xx-large)) - (var(--beacon-system-grid-columns) - 1) * var(--beacon-system-space-gutter)) / var(--beacon-system-grid-columns)) * 10 + var(--beacon-system-space-gutter) * 9);--tabs-menu-item-block-size: var(--beacon-reference-space-13)}}`;
function _(e) {
  return e <= z.DEFAULT ? v.DEFAULT : e <= z.MEDIUM ? v.MEDIUM : e <= z.LARGE ? v.LARGE : v.XLARGE;
}
function J(e, a) {
  const { scrollTop: t } = e, n = 0, s = "scrolled-close-button-row", r = a.classList.contains(s);
  t !== n && a.classList.add(s), t === n && r && a.classList.remove(s);
}
function Q(e) {
  return {
    firstVisibleTabIndex: 0,
    lastVisibleTabIndex: e - 1
  };
}
function ee(e, a, t, n) {
  const s = a - 1, r = t - 1, l = n ? 1 : 0, b = {
    firstVisibleTabIndex: 0,
    lastVisibleTabIndex: s - l
  };
  return t < a && (b.lastVisibleTabIndex = r), e >= a && (b.firstVisibleTabIndex = e - s, b.lastVisibleTabIndex = e - l), b;
}
function O(e, a, t, n, s) {
  return s ? Q(t) : ee(
    e,
    a,
    t,
    n
  );
}
const ae = M`[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab]{inline-size:100%}[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=secondary],[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=tertiary]{inline-size:fit-content;margin-inline-end:var(--beacon-system-space-micro-maxi)}[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=secondary]:last-of-type,[beacon-tag-name=beacon-tabs] [beacon-tag-name=beacon-tab][variant=tertiary]:last-of-type{margin-inline-end:0}`, te = M`:host{margin:auto;max-inline-size:var(--beacon-system-breakpoint-xxx-large)}[beacon-tag-name=beacon-tab]{inline-size:100%}.tablist,.menu-tablist{display:flex;inline-size:100%}.tablist{-webkit-hyphens:auto;hyphens:auto;max-inline-size:100vw;overflow-wrap:anywhere}.menu-tablist{flex-direction:column;overflow:auto;padding-block-start:var(--beacon-system-space-cell-contained)}:host([tab-type=stacked-icon][scrollable]),:host([tab-type=inline-icon][scrollable]){--tab-width-non-scrollable: 100%}:host([tab-type=stacked-icon][scrollable]) .tablist,:host([tab-type=inline-icon][scrollable]) .tablist{inline-size:max-content}:host([tab-type=inline-icon][scrollable][variant=secondary]) .tablist{inline-size:100%}:host([variant=secondary]) .container{block-size:var(--tabs-size-block-size-secondary);border-block-end:var(--beacon-system-width-border-normal, 2px) solid var(--beacon-system-color-border-0);margin-block:var(--beacon-system-space-micro-maxi)}:host([variant=tertiary]) .container{block-size:var(--tabs-tab-size-block-size-tertiary);margin-block:var(--beacon-system-space-micro-maxi)}:host([variant=secondary]) .tablist:focus-within,:host([variant=tertiary]) .tablist:focus-within{block-size:calc(100% + var(--total-ring-width))}:host([variant=secondary][scrolled]) .container,:host([variant=tertiary][scrolled]) .container{inline-size:100vw;inset-inline-start:0;position:absolute}:host([variant=secondary][scrolled]) .spacer{block-size:calc(var(--beacon-reference-space-5) + var(--tabs-size-block-size-secondary))}:host([variant=tertiary][scrolled]) .spacer{block-size:calc(var(--beacon-reference-space-5) + var(--tabs-tab-size-block-size-tertiary))}:host([scrollable]){--scrollbar-visible: hidden;--scrollbar-hover-visible: hidden}:host([scrollable]) ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}:host([scrollable]) ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}:host([scrollable]) ::-webkit-scrollbar{display:none}:host([scrollable]) .tablist{overflow-x:auto}:host([scrollable]) .tablist:hover{--scrollbar-visible: var(--scrollbar-hover-visible)}:host([scrollable]) ::-webkit-scrollbar-thumb{visibility:var(--scrollbar-visible)}:host(:not([scrollable])) dialog{--override-icon-button-bg-color: var(--beacon-system-color-background-primary);--override-icon-button-bg-color-hover: rgb(7 96 141 / 100%);--override-icon-button-bg-color-pressed: rgb(6 83 121 / 100%)}:host([overflowing-x=true]:not([scrollable])){--tabs-overflow-wrapping: normal}:host([tab-type=stacked-icon]:not([scrollable])){--tab-width-non-scrollable: 100%}.overlay{--close-button-padding-block: var(--beacon-reference-space-3) 0;align-items:center;background-color:#002f48a3;display:flex;flex-direction:column;inline-size:100%;top:0;right:0;bottom:0;left:0;justify-content:center;position:fixed}.overlay ::-webkit-scrollbar{inline-size:calc(.875 * var(--beacon-reference-space-5))}.overlay ::-webkit-scrollbar-thumb{background:var(--beacon-component-scrollbar-color-background-thumb);background-clip:content-box;border:var(--beacon-reference-space-2) solid transparent;border-radius:calc(.875 * var(--beacon-reference-space-5))}.overlay dialog{align-items:center;background-color:var(--beacon-system-color-background-primary);block-size:100dvh;border:0;box-shadow:0 2px 4px -2px rgba(var(--beacon-system-color-shadow-high),.8);box-sizing:border-box;display:flex;flex-direction:column;inline-size:var(--tabs-menu-max-inline-size);max-block-size:var(--tabs-menu-max-block-size);padding:0}.overlay dialog h2{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-serif-headline-200);color:var(--beacon-reference-palette-grayscale-white);display:flex;margin:0}.overlay dialog .scrolled-close-button-row{--close-button-padding-block: var(--beacon-reference-space-3);box-shadow:0 2px 4px -2px rgba(var(--beacon-system-color-shadow-high),.8)}.close-button-row{background-color:var(--beacon-system-color-background-primary);display:flex;flex-direction:row-reverse;inline-size:100%;inset-block-start:0;padding:var(--beacon-reference-space-3);position:sticky}.close-button-row [beacon-tag-name=beacon-icon-button]{padding-block:var(--close-button-padding-block);padding-inline-end:var(--beacon-reference-space-3)}.menu-item{--menu-item-underline: initial;align-items:center;background-color:var(--beacon-system-color-background-primary);border:0;box-sizing:border-box;color:var(--beacon-system-color-text-primary);cursor:default;display:flex;inline-size:100%;justify-content:center;min-block-size:var(--tabs-menu-item-block-size);padding:var(--tabs-menu-item-space-padding)}.menu-item[aria-selected=true]{background-color:var(--beacon-component-tab-menu-color-background-primary-active)}.menu-item[aria-selected=true] span{font:var(--beacon-system-font-weight-bold) var(--beacon-system-font-size-sans-serif-body-200)}.menu-item span{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-200);padding-block-start:var(--tabs-menu-item-space-padding-block-start);text-decoration:var(--menu-item-underline)}.menu-item:focus-visible{box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1;align-self:center;inline-size:calc(100% - var(--total-ring-width))}.menu-item--btn{cursor:pointer}.menu-item:hover{--menu-item-underline: underline}.menu-item:first-of-type{margin-block-start:var(--tabs-menu-item-space-margin-block-start)}.menu-item:last-of-type{margin-block-end:var(--beacon-system-space-organism-jumbo)}.hide,::slotted(.hide){display:none}@media (width >= 320px){:host([tab-type=inline-icon]){--tab-width-non-scrollable: 100%}:host([tab-type=inline-icon]) .tablist{inline-size:100%}}@media (width >= 640px){:host([scrollable]) ::-webkit-scrollbar{display:block}:host([scrollable][variant=primary]){--scrollbar-hover-visible: visible}.overlay dialog{block-size:unset;max-block-size:100dvh}}`;
var B = (e) => {
  throw TypeError(e);
}, I = (e, a, t) => a.has(e) || B("Cannot " + t), ne = (e, a, t) => (I(e, a, "read from private field"), t ? t.call(e) : a.get(e)), se = (e, a, t) => a.has(e) ? B("Cannot add the same private member more than once") : a instanceof WeakSet ? a.add(e) : a.set(e, t), x = (e, a, t, n) => (I(e, a, "write to private field"), a.set(e, t), t), oe = Object.defineProperty, ie = Object.getOwnPropertyDescriptor, i = (e, a, t, n) => {
  for (var s = n > 1 ? void 0 : n ? ie(a, t) : a, r = e.length - 1, l; r >= 0; r--)
    (l = e[r]) && (s = (n ? l(a, t, s) : l(s)) || s);
  return n && s && oe(a, t, s), s;
};
const $ = "beacon-tabs", re = ["beacon-icon-button", "beacon-tab"], u = "hide", ce = "1", le = "", be = "tabChildren", de = "currentMaxTabs", he = "scrollable", ue = "tabType", me = "variant", ve = "DIALOG", pe = "tab-list", ge = 320;
var m, c;
const o = (c = class extends Y(D).with(j) {
  constructor() {
    super(...arguments), se(this, m), this.beaconTagName = $, this.focusOverride = !0, this.currentTotalTabs = 0, this.currentMaxTabs = v.XLARGE, this.scrollable = !1, this.scrolled = !1, this.closeOnClickOut = !0, this.variant = h.PRIMARY, this.tabType = N.STACKED_ICON, this.menuTitle = "Choose a view:", x(this, m, ""), this.menuOpen = !1, this.markedAsOverflowingX = !1, this.markedAsMenuOverFlowingY = !1, this.id = q(), this.tabsResizeObserver = new ResizeObserver((e) => {
      var a, t;
      let n, s;
      const r = e.find(
        (k) => k
      ), { borderBoxSize: l, contentRect: b } = r;
      if (l && (s = Array.isArray(l) ? l[0] : l), ((a = r == null ? void 0 : r.target) == null ? void 0 : a.tagName) === ve && this.menuOpen && !this.markedAsMenuOverFlowingY) {
        const k = Math.ceil(s.blockSize || b.height), P = r.target.scrollHeight;
        this.observeHeight(k, P);
      } else (r == null ? void 0 : r.target.id) === pe ? (n = Math.ceil(s.inlineSize || b.width), this.observePrimaryTabsWidth(n)) : (n = Math.ceil((t = s.inlineSize || (b == null ? void 0 : b.width)) != null ? t : 0), this.observeBodyWidth(n));
    }), this.toggleTabListScrollClass = () => {
      const { scrollLeft: e } = this.tabListElement;
      e === 0 ? this.scrolled = !1 : this.scrolled = !0;
    }, this.buildTabMenuItem = (e) => g`<button
      role="tab"
      data-metrics-type="${L.dataMetricsType.TAB}"
      value="${e.value}"
      class="menu-item menu-item--btn"
      aria-selected="${e.ariaSelected}"
      @click=${this.handleMenuTabClick}>
      <span>${e.label}</span>
    </button>`, this.buildTabMenu = (e) => g`${e.map((a) => this.buildTabMenuItem(a))}`, this.handleKeydown = (e) => {
      this.handleArrowControlKeydown(
        e,
        this.getArrowControlElements(),
        "horizontal",
        c.arrowControlFocusCallback
      );
    };
  }
  static get styles() {
    return [super.styles, te];
  }
  static get lightDOMStyles() {
    return [...super.lightDOMStyles, Z, ae];
  }
  get selected() {
    return ne(this, m);
  }
  set selected(e) {
    const a = parseInt(e, 10);
    if (isNaN(a)) {
      const t = this.querySelector(
        this.getScopedTagName("beacon-tab") + `#${e}`
      );
      x(this, m, t instanceof S ? t.value : e);
    } else
      x(this, m, a.toString());
  }
  /**
   * Getter for a Boolean property indicating whether the more button and more menu should be rendered
   */
  get shouldShowMore() {
    return !this.scrollable && this.currentTotalTabs > this.currentMaxTabs && this.variant === h.PRIMARY;
  }
  /**
   * Getter for the Scroll Width of the tab list, used in calculating overflow
   */
  get TabsWidth() {
    return this.tabListElement.scrollWidth;
  }
  /**
   * Observer logic to conditionally apply the overflow class
   * and update the max amount of visible tabs allowed based
   * on an input tabList width
   * @param width the width of the tablist contentRect
   */
  observePrimaryTabsWidth(e) {
    this.handleOverflowing();
    const a = _(e);
    this.currentMaxTabs !== a && (this.currentMaxTabs = a, this.requestUpdate());
  }
  /**
   * Conditionally applies a scroll listener to the moreMenu if and only if the moreMenu is overflowing
   * for the first time
   * @param moreMenuHeight the height of the more menu currently visible on the screen
   * @param moreMenuScrollHeight the complete height of the more menu including what's vertically scrollable
   */
  observeHeight(e, a) {
    this.closeButtonRow && e < a && (this.markedAsMenuOverFlowingY = !0, this.tabMenu.addEventListener(y.SCROLL, () => {
      J(this.tabMenu, this.closeButtonRow);
    }));
  }
  /**
   * Checks the width of the body element. If it's at mobile breakpoint width adds scroll listener that toggles
   * full-width 'scrolled' styles for tab-list. For performance reasons, removes scroll listener when width is
   * bigger than mobile breakpoint.
   * @param width of the body element
   */
  observeBodyWidth(e) {
    e <= ge ? (this.toggleTabListScrollClass(), this.tabListElement.addEventListener(
      y.SCROLL,
      this.toggleTabListScrollClass
    )) : (this.tabListElement.removeEventListener(
      y.SCROLL,
      this.toggleTabListScrollClass
    ), this.scrolled = !1);
  }
  /**
   * checks the scrollWidth of the tab list element,
   * then compares the scrollWidth to the window innerWidth
   * to determine if the tabs are overflowing.
   * Applies an overflow class to the tabs if they are overflowing.
   */
  handleOverflowing() {
    let e = !1;
    const a = Math.ceil(
      this.tabListElement.getBoundingClientRect().width
    );
    this.markedAsOverflowingX || (e = this.TabsWidth > a), e && !this.markedAsOverflowingX && (this.markedAsOverflowingX = !0);
  }
  tearDownTabs() {
    this.focusTrapObject && this.focusTrapObject.deactivate(), this.tabsResizeObserver.disconnect(), (this.variant === h.SECONDARY || this.variant === h.TERTIARY) && this.tabListElement.removeEventListener(
      y.SCROLL,
      this.toggleTabListScrollClass
    );
  }
  /**
   * function attached to the more menu's close button
   * that hides the menu upon clicking.
   * @param event a user interaction generated Click event
   */
  handleClose(e) {
    e.stopPropagation(), this.hideMenu(), this.focusSelectedTab();
  }
  /**
   * sets the clicked tab to active,
   * and updates the rendering according to updateCurrentlyActiveTab
   * @param event a user interaction generated Click event
   */
  handleTabClick(e) {
    this.emitClick();
    const a = e.target;
    a.value && this.updateCurrentlyActiveTab(a.value);
  }
  /**
   * Sets the tabs selected attribute,
   * then sets the currently visible tab and tab panel
   * to match the selected attribute
   * @param selected the value attribute of a clicked tab or tab menu-item
   */
  updateCurrentlyActiveTab(e) {
    this.selected = e, this.deselectAllTabs(), this.hideAllTabPanels(), this.selectClickedTab(this.selected), this.displaySelectedTabPanel(this.selected);
  }
  /**
   * Closes the more menu and
   * Sets which tab is currently active based on the menu item clicked,
   * then shifts the visible tab range to match if the clicked tab value
   * is greater than what's currently visible.
   * @param event A user generated Click event
   */
  handleMenuTabClick(e) {
    const a = e.currentTarget;
    this.emitClick();
    const t = parseInt(a.value, 10), n = O(
      t,
      this.currentMaxTabs,
      this.currentTotalTabs,
      this.shouldShowMore,
      this.scrollable
    );
    this.updateCurrentlyActiveTab(a.value), c.showTabsInRange(n, this.tabChildren), this.hideMenu(), this.focusSelectedTab();
  }
  /**
   * Sets the arrow-control arrowControlElements array to the currently visible elements
   * and the more button at the end if needed.
   */
  getArrowControlElements() {
    return this.shouldShowMore && this.moreButton != null ? [...c.getVisibleTabs(this.tabChildren), this.moreButton] : c.getVisibleTabs(this.tabChildren);
  }
  /**
   * Closes the more menu dialog, when the user clicks outside of the dialog and
   * the closeOnClickOut parameter is true.
   * @param event a user interaction generated Click event
   */
  handleMenuClickBlur(e) {
    this.closeOnClickOut && this.menuOpen && e.target === this.tabMenuOverlay && this.hideMenu();
  }
  /**
   * Sets currently active tab of the slotted tabChildren based on the clicked tab's value
   * @param clickedValue the value attribute of a user clicked tab
   */
  selectClickedTab(e) {
    this.tabChildren.forEach((a) => {
      a.value === e && (a.ariaSelected = "true");
    });
  }
  /**
   * Sets focus to the currently selected tab after selecting the tab from the menu
   */
  focusSelectedTab() {
    this.tabChildren.forEach((e) => {
      e.ariaSelected === "true" && e.focus();
    });
  }
  /**
   * sets the active value of each slotted tab to false
   */
  deselectAllTabs() {
    this.tabChildren.forEach((e) => {
      e.ariaSelected = "false";
    });
  }
  /**
   * Removes the hide class from the tab panel with a value matching the input value attribute
   * @param clickedValue the value attribute of the tab clicked corresponding with the tab panel value
   */
  displaySelectedTabPanel(e) {
    this.tabPanels.forEach((a) => {
      a.value === e && (a.ariaHidden = "false");
    });
  }
  /**
   * Applies the hide class to each slotted tab panel
   * setting their display to none.
   */
  hideAllTabPanels() {
    this.tabPanels.forEach((e) => {
      e.ariaHidden = "true";
    });
  }
  /**
   * applies the hide css class to the overlay div
   * to hide the more menu modal.
   * Triggered by blur, the menu close button, or clicking an option
   */
  hideMenu() {
    this.tabMenuOverlay.classList.add(u), this.menuOpen = !1, this.focusTrapObject.deactivate(), this.tabsResizeObserver.unobserve(this.tabMenu), X();
  }
  /**
   * remove the hide css class from the overlay div
   * to show the more menu modal.
   * Triggered by blur, or menu click
   * Focuses on first tabbable element within the more menu
   */
  showMenu() {
    var e, a;
    this.tabMenuOverlay.classList.remove(u), this.menuOpen = !0, this.focusTrapObject.activate(), this.tabsResizeObserver.observe(this.tabMenu), (a = (e = this.closeButton.shadowRoot) == null ? void 0 : e.querySelector("button")) == null || a.focus(), H();
  }
  /**
   * applies the hide class setting display to none on the input tab
   * @param tab BeaconTab in the tabChildren slot to hide
   */
  static hideTab(e) {
    e.classList.add(u);
  }
  /**
   * removes the hide class setting display to none on the input tab
   * @param tab BeaconTab in the tabChildren slot to show
   */
  static showTab(e) {
    e.classList.remove(u);
  }
  /**
   * Getter for all currently slotted tabs without the .hide class applied
   * @param tabs an Array of slotted Beacon Tab components
   * @returns an array of tabs without the .hide class applied
   */
  static getVisibleTabs(e) {
    return e.filter(
      (a) => !a.classList.contains(u)
    );
  }
  /**
   * Hides all tabs outside of the specified range
   * and shows all tabs inside the range by applying and
   * removing the hide class to the slotted tabChildren
   * @param firstVisibleTabIndex the inclusive starting index range to show tabs
   * @param lastVisibleTabIndex the inclusive ending index range to show tabs
   * @param tabs the slotted tabChildren
   */
  static showTabsInRange({
    firstVisibleTabIndex: e,
    lastVisibleTabIndex: a
  }, t) {
    t.forEach((n, s) => {
      s < e || s > a ? c.hideTab(n) : c.showTab(n);
    });
  }
  /**
   * Applies the .hide class setting display: none on
   * each slotted tab component.
   */
  hideAllTabs() {
    this.tabChildren.forEach((e) => {
      e.classList.add(u);
    });
  }
  /**
   * Removes the .hide class from each slotted tab component.
   */
  showAllTabs() {
    this.tabChildren.forEach((e) => {
      e.classList.remove(u);
    });
  }
  /**
   * Overridden.
   * checks if the amount of slotted tabChildren changed, to update the "watching"
   * currentTotalTab attribute accordingly.
   * Also calls updateShownTabs() to re-render tabs accordingly, when the max amount
   * of visible tabs allowed changes.
   * @param changedProperties Inherited Map of properties changed during a component's update lifeCycle
   */
  async willUpdate(e) {
    e.has(be) && (this.currentTotalTabs = this.tabChildren.length), e.has(de) && this.updateShownTabs(), e.has(he) && this.updateShownTabs(), e.has(ue) && this.applyTabType(this.tabChildren), e.has(me) && this.applyTabVariant(this.tabChildren);
  }
  /**
   * Repeated update lifecyle logic to update tab visibility based on which value is currently selected.
   * Will shift the visible tab range downwards if the max tabs allowed decreases on a resize.
   */
  updateShownTabs() {
    const e = parseInt(this.selected, 10), a = O(
      e,
      this.currentMaxTabs,
      this.currentTotalTabs,
      this.shouldShowMore,
      this.scrollable
    );
    c.showTabsInRange(a, this.tabChildren);
  }
  /**
   * Applies the variant attribute from the parent to all slotted
   * tab components
   * @param tabs the slotted Tab Components from this.tabChildren
   */
  applyTabVariant(e) {
    e.forEach((a) => {
      a.variant = this.variant;
    });
  }
  /**
   * Applies the tabType attribute from the parent to all slotted
   * tab components
   * @param tabs the slotted Tab Components from this.tabChildren
   */
  applyTabType(e) {
    (this.variant === h.PRIMARY || h.SECONDARY) && e.forEach((a) => {
      a.tabType = this.tabType;
    });
  }
  /**
   * Iterates over the loaded tabPanels and sets their
   * value attribute to 1 + index. Necessary for tab hiding
   * and shifting logic.
   * @param tabs the loaded Array of slotted Beacon Tab components
   */
  static initializeTabValues(e) {
    e.forEach((a, t) => {
      a.value = `${t + 1}`;
    });
  }
  /**
   * Iterates over the loaded tabPanels and sets their
   * value attribute to 1 + index. Necessary for tab hiding
   * and shifting logic.
   * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
   */
  static initializeTabPanelValues(e) {
    e.forEach((a, t) => {
      a.value = `${t + 1}`;
    });
  }
  /**
   * Iterates over the loaded tabPanels and prefixes their IDs with the tab component's
   * input or randomly generated Unique ID
   * @param tabPanels the loaded Array of slotted Beacon Tab Panel components
   * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
   */
  static initializeTabPanelIDs(e, a) {
    e.forEach((t) => {
      t.id || (t.id = `${a}-tabpanel-${t.value}`);
    });
  }
  /**
   * Iterates over the loaded tab components and prefixes their IDs with the tab component's
   * input or randomly generated Unique ID. Also updates attributes dependent on the tab ID including
   * ariaControls.
   * @param tabPanels the loaded Array of slotted Beacon Tab components
   * @param uniqueID the Tab Component's input ID or randomly generated fallback ID.
   */
  static initializeTabIDs(e, a, t) {
    e.forEach((n) => {
      var s;
      n.id || (n.id = `${a}-tab-${n.value}`);
      const r = `${a}-tabpanel-${n.value}`;
      if (t) {
        const l = t.find(
          (b) => b.value === n.value
        );
        n.ariaControls = (s = l == null ? void 0 : l.id) != null ? s : r;
      } else
        n.ariaControls = r;
    });
  }
  /**
   * Fallback case for the initially selected tab when the user selected value
   * is invalid or not supplied. Sets the first tab and tab panel to active.
   */
  setActiveToFirst() {
    this.updateCurrentlyActiveTab(ce);
  }
  /**
   * Sets the currently active tab to the string input,
   * if the string input is within the range of currently slotted tabs,
   * and sets the active tab to the first slotted tab otherwise.
   * @param selected tab with matching value to set as active, this.selected
   * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
   */
  initializeUserSelectedTab(e, a) {
    const t = parseInt(this.selected, 10);
    t > a || t < 0 ? this.setActiveToFirst() : this.updateCurrentlyActiveTab(e);
  }
  /**
   * Sets the currently active tab to the user supplied selected value
   * if it exists and is valid, or to the first slotted tab otherwise.
   * @param selected tab with matching value to set as active, this.selected
   * @param currentTotalTabs the length of currently slotted tab array, this.currentTotalTabs
   */
  initializeSelectedTab(e, a) {
    e !== le ? this.initializeUserSelectedTab(e, a) : this.setActiveToFirst();
  }
  removeArrowControlKeyboardListeners() {
    var e;
    this.tabChildren.forEach((a) => {
      a.removeEventListener("keydown", this.handleKeydown);
    }), this.shouldShowMore && ((e = this.moreButton) == null || e.removeEventListener("keydown", this.handleKeydown));
  }
  /**
   * Keyboard listeners for all arrow-controlled children. Makes the events
   * store a reference (event.currentTarget) to the focused tab to simplify logic
   */
  attachArrowControlKeyboardListeners() {
    var e;
    this.tabChildren.forEach((a) => {
      a.addEventListener("keydown", this.handleKeydown);
    }), this.shouldShowMore && ((e = this.moreButton) == null || e.addEventListener("keydown", this.handleKeydown));
  }
  /**
   * Basic focus callback for ArrowControl
   * @param tab
   */
  static arrowControlFocusCallback(e) {
    e instanceof S && e.focus();
  }
  async handleSlotChange() {
    await this.initializeTabs(), this.requestUpdate();
  }
  /**
   * When the tabs component first Updates or the slot changes, it waits for the slotted
   * tab, and tab panel components, selects the appropriate tab, hides the rest,
   * and applies some attributes from the tabs component to each tab/ tab panel, then
   * hides the tabMenuOverlay if it's shown.
   */
  async initializeTabs() {
    var e;
    await Promise.all(this.tabChildren.map((a) => a.updateComplete)), await Promise.all(this.tabPanels.map((a) => a.updateComplete)), this.shouldShowMore && await ((e = this.moreButton) == null ? void 0 : e.updateComplete), this.currentTotalTabs = this.tabChildren.length, c.initializeTabPanelValues(this.tabPanels), c.initializeTabValues(this.tabChildren), c.initializeTabPanelIDs(this.tabPanels, this.id), c.initializeTabIDs(this.tabChildren, this.id, this.tabPanels), this.updateShownTabs(), this.applyTabVariant(this.tabChildren), this.applyTabType(this.tabChildren), this.removeArrowControlKeyboardListeners(), this.attachArrowControlKeyboardListeners(), this.initializeSelectedTab(this.selected, this.currentTotalTabs), this.tabMenuOverlay && this.hideMenu();
  }
  /**
   * When the tabs component first Updates, it waits for the slotted
   * tab, and tab panel components, selects the appropriate tab, hides the rest,
   * and applies some attributes from the tabs component to each tab/ tab panel, then
   * hides the tabMenuOverlay if it's shown.
   */
  async firstUpdated() {
    this.variant !== h.PRIMARY && (this.scrollable = !0), await this.initializeTabs(), this.variant === h.PRIMARY ? this.tabsResizeObserver.observe(this.tabListElement) : this.tabsResizeObserver.observe(document.body), this.renderStyles(
      "lightDOMStyles",
      `${this.beaconTagName}-light-DOM-styles`
    ), this.shouldShowMore && (this.focusTrapObject = K(this.tabMenuOverlay, {
      fallbackFocus: this.closeButton,
      // focusTrap needs a fallbackFocus node if there are no focusable nodes found in the host element
      tabbableOptions: {
        getShadowRoot: !0
        // option that allows focusTrap to penetrate closed shadowRoot's and grab focusable nodes
      },
      // overrides keyForward and keyBackward events to include arrowKey navigation
      isKeyForward: (e) => e.key === f.DOWN || e.key === f.RIGHT || e.key === E.TAB,
      isKeyBackward: (e) => e.key === f.UP || e.key === f.LEFT || e.shiftKey && e.key === E.TAB,
      escapeDeactivates: () => (this.hideMenu(), !0)
    })), super.firstUpdated();
  }
  /**
   * renders a `<beacon-tab>` component with the more attribute set to true
   * and an icon matching the `<beacon-tabs>` tab type property
   * @returns An HTML `<beacon-tab>` with more attribute set to true and a slotted more icon
   */
  renderMoreButton() {
    return C`<${this.getScopedTag("beacon-tab")}
      label="More"
      variant=${this.variant}
      tab-type=${this.tabType}
      value="-1"
      @beacon-event-click=${this.showMenu}
      more
      aria-haspopup="menu"
    >
      <svg slot="tab-icon" width="17" height="4" viewBox="0 0 17 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2.5" cy="2" r="2" fill="white" />
        <circle cx="8.5" cy="2" r="2" fill="white" />
        <circle cx="14.5" cy="2" r="2" fill="white" />
      </svg>
    </${this.getScopedTag("beacon-tab")}>`;
  }
  /**
   * Renders a dialog containing the mapped values of the slotted tabs
   * @returns an HTML dialog containing a tablist of mapped tab items
   */
  renderMoreMenu() {
    return g`<div
      class="overlay hide"
      @click=${this.handleMenuClickBlur}
      id="menu"
      data-metrics-location="${L.dataMetricsLocation.PU}">
      <dialog>
        <div class="close-button-row">
          ${C`<${this.getScopedTag("beacon-icon-button")} @beacon-event-click=${this.handleClose} label="close-button" variant="primary">
            <svg slot="icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 1L0.999999 13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M1 1L13 13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </${this.getScopedTag("beacon-icon-button")}>`}
        </div>
        <div class="menu-item">
          <h2>${this.menuTitle}</h2>
        </div>
        <div class="menu-tablist" role="tablist">
          ${this.buildTabMenu(this.tabChildren)}
        </div>
      </dialog>
    </div>`;
  }
  render() {
    return g`<div class="container">
        <div id="tab-list" role="tablist" class="tablist">
          <slot
            name="tab-children"
            @beacon-event-click=${this.handleTabClick}
            @slotchange=${this.handleSlotChange}></slot>
          ${this.shouldShowMore ? this.renderMoreButton() : A}
        </div>
      </div>
      <div class="spacer"></div>
      <slot name="tab-panel" @slotchange=${this.handleSlotChange}></slot>
      ${this.shouldShowMore ? this.renderMoreMenu() : A}`;
  }
}, m = /* @__PURE__ */ new WeakMap(), c.tagName = $, c.nestedComponents = re, c);
i([
  p("#menu")
], o.prototype, "tabMenuOverlay", 2);
i([
  p("#menu dialog")
], o.prototype, "tabMenu", 2);
i([
  W("#menu button.menu-item")
], o.prototype, "menuTabs", 2);
i([
  p(
    '#menu dialog .close-button-row [beacon-tag-name="beacon-icon-button"]'
  )
], o.prototype, "closeButton", 2);
i([
  p("#menu dialog .close-button-row")
], o.prototype, "closeButtonRow", 2);
i([
  p("#tab-list")
], o.prototype, "tabListElement", 2);
i([
  p("[more]")
], o.prototype, "moreButton", 2);
i([
  R(
    { slot: "tab-children", selector: "beacon-tab" },
    !0
  )
], o.prototype, "tabChildren", 2);
i([
  R(
    { slot: "tab-panel", selector: "beacon-tab-panel" },
    !0
  )
], o.prototype, "tabPanels", 2);
i([
  T()
], o.prototype, "currentTotalTabs", 2);
i([
  T()
], o.prototype, "currentMaxTabs", 2);
i([
  d({ reflect: !0, type: Boolean })
], o.prototype, "scrollable", 2);
i([
  d({ reflect: !0, type: Boolean })
], o.prototype, "scrolled", 2);
i([
  d({ type: Boolean, attribute: "close-on-click-out" })
], o.prototype, "closeOnClickOut", 2);
i([
  d({ reflect: !0 })
], o.prototype, "variant", 2);
i([
  d({ reflect: !0, attribute: "tab-type" })
], o.prototype, "tabType", 2);
i([
  d({ attribute: "menu-title" })
], o.prototype, "menuTitle", 2);
i([
  d()
], o.prototype, "selected", 1);
i([
  T()
], o.prototype, "menuOpen", 2);
i([
  d({ reflect: !0, attribute: "overflowing-x" })
], o.prototype, "markedAsOverflowingX", 2);
i([
  T()
], o.prototype, "markedAsMenuOverFlowingY", 2);
i([
  d({ reflect: !0 })
], o.prototype, "id", 2);
i([
  G
], o.prototype, "tearDownTabs", 1);
let w = o;
const Le = (e) => (V(e, w), F({
  tagName: e ? e + "-" + w.tagName : w.tagName,
  elementClass: w,
  react: U,
  events: {
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  Le as default,
  Le as reactBeaconTabs
};
